var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clear"},[_c('div',{attrs:{"id":"portfolio-chart"}},[(_vm.forecasts)?_c('Chart',{attrs:{"series":_vm.forecasts,"height":"300px","portfolio_chart":"true"}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }